var currency1 = $('body').attr('data-currency');
var market = $('body').attr('data-market');

// ----------------------------------------------------------------------------
// Sticky top menu visibility on scroll
// ----------------------------------------------------------------------------

$(window).on('scroll', function () {
  var scroll = $(window).scrollTop();
  var isPastThreshold = scroll >= 2000;

  $('.pdp-menu-top').css('display', isPastThreshold ? 'flex' : 'none');
  $('.pdp-menu.flex').css('display', isPastThreshold ? 'flex' : 'none');
});

// ----------------------------------------------------------------------------
// Sticky mobile Add-to-Cart bar
// ----------------------------------------------------------------------------

(function setupStickyAddToCart() {
  var $stickyBar = $('section.pdp-menu.flex.wf-section.product_menu_section');
  var $mainAtc = $('.add-to-cart-holder .atcButtonWrap');

  if (!$mainAtc.length) return;

  function toggleStickyATC() {
    // Desktop: always hidden.
    if ($(window).width() > 767) {
      $stickyBar.removeClass('visible');
      return;
    }

    // Mobile: show once the real Add to Cart button scrolls off screen.
    var rect = $mainAtc[0].getBoundingClientRect();
    var isVisible = rect.top < window.innerHeight && rect.bottom > 0;

    $stickyBar.toggleClass('visible', !isVisible);
  }

  $(window).on('scroll load resize', toggleStickyATC);
})();

// ----------------------------------------------------------------------------
// Main PDP / cart drawer behaviour
// ----------------------------------------------------------------------------

$(document).ready(function () {
  $('.accordion_heading').on('click', function () {
    const $block = $(this).closest('.product_accordion_block');
    const $content = $block.find('.product_accordion_content');

    $block.toggleClass('active_accordion');
    $content.stop(true, true).slideToggle(300);
  });

  $('.product_size_tabs label').click(function () {
    $('.product_size_tabs label').removeClass('active_size_label');
    $(this).addClass('active_size_label');
    $('.product_size_block_row').removeClass('active_size_table');

    var size_label = $(this).attr('data-tab');
    $(`.product_size_block_row[data-content="${size_label}"]`).addClass('active_size_table');
  });

  $('.expert_product_lable').click(function () {
    $('.expert_form_container').addClass('active_form');
  });
  $('.close_btn').click(function () {
    $('.expert_form_container').removeClass('active_form');
  });

  // ---- Homepage banner A/B variant tracking helpers ----

  function caesarCushieHomepageVariantProps() {
    var raw = null,
      parsed = null,
      cookieVariant = null;

    try {
      raw = localStorage.getItem('caesar_cushie_homepage_variant') || sessionStorage.getItem('caesar_cushie_homepage_variant');
    } catch (e) {}

    if (raw) {
      try {
        parsed = JSON.parse(raw);
      } catch (e) {}
    }

    try {
      var m = document.cookie.match(/(?:^|; )caesar_cushie_homepage_variant=([^;]+)/);
      if (m) cookieVariant = decodeURIComponent(m[1]);
    } catch (e) {}

    var variant = (parsed && parsed.variant) || cookieVariant || null;
    if (variant !== 'control' && variant !== 'sleeper_sofa') variant = null;

    return {
      homepage_banner_flag_key: 'cushie-homepage-banner-routing-v1',
      homepage_banner_variant: variant,
      homepage_banner_source: (parsed && parsed.source) || null,
      homepage_banner_assigned_at: (parsed && parsed.assigned_at) || null,
      homepage_banner_smoke_test: !!(parsed && parsed.caesar_smoke_test),
      '$feature/cushie-homepage-banner-routing-v1': variant
    };
  }

  async function caesarCushiePersistHomepageVariantCartAttributes() {
    var props = caesarCushieHomepageVariantProps ? caesarCushieHomepageVariantProps() : {};
    if (!props.homepage_banner_variant) return props;

    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            caesar_homepage_banner_flag_key: props.homepage_banner_flag_key,
            caesar_homepage_banner_variant: props.homepage_banner_variant,
            caesar_homepage_banner_source: props.homepage_banner_source || '',
            caesar_homepage_banner_assigned_at: props.homepage_banner_assigned_at || '',
            caesar_homepage_banner_smoke_test: props.homepage_banner_smoke_test ? 'true' : 'false'
          }
        })
      });
    } catch (e) {}

    return props;
  }

  function sendPostHogAddToCartSuccess(payload) {
    fetch('https://us.i.posthog.com/capture/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        api_key: 'phc_qJ5kpUyq4sdJxMud3o9P3t6MYE6ibuBAcJJCmxGAks4f',
        event: 'product added to cart',
        distinct_id:
          window.ShopifyAnalytics && ShopifyAnalytics.lib
            ? ShopifyAnalytics.lib.user && ShopifyAnalytics.lib.user().traits().uniqToken
            : 'cushie-anonymous',
        properties: Object.assign(
          {
            source: 'shopify_theme_atc_success',
            caesar_tracking_version: 'cushie-theme-atc-success-2026-05-28-homepage-variant',
            trigger: 'cart_add_success',
            product_id: payload.product_id || null,
            variant_id: payload.variant_id || null,
            sku: payload.sku || null,
            quantity: payload.quantity || 1,
            url: window.location.href,
            page_path: window.location.pathname
          },
          caesarCushieHomepageVariantProps()
        )
      })
    }).catch(function () {});
  }


  /****************** Cart Recommendations ******************/
  /* async function loadRecommendations(cart) {
    const productIds = [
      ...new Set(cart.items.map(item => item.product_id))
    ];

    if (!productIds.length) {
      renderRecommendations([]);
      return;
    }

    const results = await Promise.all(
      productIds.map(async (productId) => {
        const response = await fetch(
          `${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=3&intent=related`
        );

        if (!response.ok) {
          console.error(
            `Recommendations failed for product ${productId}:`,
            response.status
          );
          return { products: [] };
        }

        return response.json();
      })
    );

    const cartProductIds = new Set(
      cart.items.map(item => Number(item.product_id))
    );

    const uniqueRecommendations = [
      ...new Map(
        results
          .flatMap(result => result.products || [])
          .filter(product => !cartProductIds.has(Number(product.id)))
          .map(product => [product.id, product])
      ).values()
    ];

    console.log("Cart product IDs:", productIds);
    console.log(
      "Recommendations per product:",
      results.map((result, index) => ({
        productId: productIds[index],
        count: result.products?.length || 0
      }))
    );
    console.log("Combined recommendations:", uniqueRecommendations);

    renderRecommendations(uniqueRecommendations);
  } */



  async function loadRecommendations(cart) {
    const cartProductIds = new Set(
      cart.items.map(item => Number(item.product_id))
    );

    let productHandles = [];

    if (market === 'uk') {
      const hasSnuggleProduct =
        cartProductIds.has(10297322864931) ||
        cartProductIds.has(10297828573475);

      const hasModularProduct = cartProductIds.has(10290461966627);

      if (hasSnuggleProduct && hasModularProduct) {
        // Both product families are in the cart: recommend both pads.
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad-uk',
          'cushie-modular-sleeper-sofa-airflow-pad-uk'
        ];
      } else if (hasModularProduct) {
        productHandles = [
          'cushie-modular-sleeper-sofa-airflow-pad-uk'
        ];
      } else if (hasSnuggleProduct) {
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad-uk'
        ];
      } else {
        // No matching UK product: show both pad families.
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad-uk',
          'cushie-modular-sleeper-sofa-airflow-pad-uk'
        ];
      }

    } else if (market === 'us') {
      if (
        cartProductIds.has(10000042393891) ||
        cartProductIds.has(10241004896547)
      ) {
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad',
          'cushie-ottoman-sleeper',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      } else if (cartProductIds.has(9891748118819)) {
        productHandles = [
          'cushie-modular-sleeper-sofa-airflow-pad',
          'cushie-ottoman-sleeper',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      } else {
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad',
          'cushie-modular-sleeper-sofa-airflow-pad',
          'cushie-ottoman-sleeper',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      }

    } else if (market === 'canada') {
      if (
        cartProductIds.has(10000042393891) ||
        cartProductIds.has(10241004896547)
      ) {
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      } else if (cartProductIds.has(9891748118819)) {
        productHandles = [
          'cushie-modular-sleeper-sofa-airflow-pad',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      } else {
        productHandles = [
          'cushie-snuggle-sleeper-sofa-bed-airflow-pad',
          'cushie-modular-sleeper-sofa-airflow-pad',
          'cushie-storage-ottoman',
          'cushie-sleeper-chaise-bed'
        ];
      }

    } else {
      productHandles = [
        'cushie-snuggle-sleeper-sofa-bed-airflow-pad',
        'cushie-modular-sleeper-sofa-airflow-pad',
        'cushie-ottoman-sleeper',
        'cushie-storage-ottoman',
        'cushie-sleeper-chaise-bed'
      ];
    }

    try {
      const results = await Promise.all(
        productHandles.map(async (handle) => {
          const url = `${window.Shopify.routes.root}products/${handle}.js`;

          try {
            const response = await fetch(url);

            if (!response.ok) {
              console.error(
                `Failed to load product ${handle}:`,
                response.status
              );
              return null;
            }

            return await response.json();
          } catch (error) {
            console.error(`Request failed for ${handle}:`, error);
            return null;
          }
        })
      );

      const recommendations = results
        .filter(Boolean)
        .filter(product => !cartProductIds.has(Number(product.id)));

      console.log('Loaded recommendations:', recommendations);

      renderRecommendations(recommendations);
    } catch (error) {
      console.error('Error loading fixed recommendations:', error);
      renderRecommendations([]);
    }
  }



  function renderRecommendations(products) {

    const recommendationsContainer = document.querySelector(".cart-drawer-recommendations");

    const recommendationsWrap = document.querySelector(
      ".recommendations-wrapper"
    );

    if (!recommendationsWrap) {
      return;
    }

    recommendationsWrap.innerHTML = "";

    let count = 0;

    products.forEach((product) => {

      const upsellProductId = null;

      if (upsellProductId && product.id == upsellProductId) {
        return;
      }

      if (count >= 6) {
        return;
      }

      count++;

      const variant = product.variants?.[0];

      if (!variant) {
        return;
      }

      const productUrl = `/products/${product.handle}`;
      const imageUrl = product.featured_image
        ? `${product.featured_image}&width=200`
        : "";

      /* const price = Shopify.formatMoney(
        product.price,
        window.Shopify.money_format
      );

      const compareAtPrice =
        product.compare_at_price &&
        product.compare_at_price > product.price
          ? Shopify.formatMoney(
              product.compare_at_price,
              window.Shopify.money_format
            )
          : ""; */
        
      function formatPrice(priceInCents) {
        return `${currency1}${(Number(priceInCents) / 100).toLocaleString(
          document.documentElement.lang || 'en-GB',
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }
        )}`;
      }

      let price = '';
      let compareAtPrice = '';

      if ($('.recommendatiations-hidden-wrapper').length > 0) {
        const currentWrapper = $(
          '.recommendatiations-hidden-wrapper .recommendations-hidden-container[data-pid="' +
            product.id +
            '"]'
        );

        if (currentWrapper.length > 0) {
          const sprice = Number(currentWrapper.find('.recommendations-hidden-item').attr('data-price'));
          const cprice = Number(currentWrapper.find('.recommendations-hidden-item').attr('data-comp-price'));

          price = formatPrice(sprice);

          compareAtPrice =
            Number.isFinite(cprice) && cprice > sprice
              ? formatPrice(cprice)
              : '';
        }
      } else {
        price = formatPrice(product.price);

        compareAtPrice =
          product.compare_at_price > product.price
            ? formatPrice(product.compare_at_price)
            : '';
      }

      const hasMultipleVariants = product.variants && product.variants.length > 1;

      const optionsHtml = (product.options || [])
      .map((option, index) => {
        const optionName =
          typeof option === "string" ? option : option.name;

        const optionValues = [
          ...new Set(
            (product.variants || [])
              .map((variant) => variant.options?.[index])
              .filter(Boolean)
          ),
        ];

        if (!optionName || optionValues.length === 0) {
          return "";
        }

        return `
          <div class="rec-popup-group" data-index="${index}">
            <label>${escapeHtml(optionName)}</label>
            <select
              name="options[${escapeHtml(optionName)}]"
              data-option-index="${index}"
            >
              ${optionValues
                .map(
                (value) => `
                  <option value="${escapeHtml(value)}">${escapeHtml(value)}</option>`
                )
                .join("")}
            </select>
          </div>
        `;
      })
      .join("");

      const productHtml = `
        <div class="cart-recommend-product" data-product-id="${product.id}">
          <div class="rec-content-wrapper">
            <a href="${productUrl}" class="rec-img-block">
              ${
                imageUrl
                  ? `
                    <img
                      src="${imageUrl}"
                      alt="${escapeHtml(product.title)}"
                      width="200"
                      loading="lazy"
                    >
                  `
                  : ""
              }
            </a>

            <div class="rec-info-block">

              <a href="${productUrl}" class="rec-prd-title">
                ${escapeHtml(product.title)}
              </a>

              <div class="price">
                ${
                  compareAtPrice
                    ? `<s>${compareAtPrice}</s>`
                    : ""
                }

                <span>${price}</span>
              </div>

            </div>
          </div>

          ${
            hasMultipleVariants
              ? `
                <button
                  type="button"
                  class="cart-recommend-product-atc has-popup"
                  data-product-id="${product.id}"
                >
                  Choose Options
                </button>

                <div class="recommend-product-options" style="display:none;">
                  <div class="rec-popup-head">
                    <img class="recPopupImg" src="${imageUrl}"
                      alt="${escapeHtml(product.title)}">
                    <span class="rec-popup-title recPopupTitle"> ${escapeHtml(product.title)}</span>
                    <div class="rec-popup-price">
                    ${
                      compareAtPrice
                        ? `<span class="rec-popup-compare"><s>${compareAtPrice}</s></span>`
                        : ""
                    }
                    <span class="rec-popup-now recPopupPrice">${price}</span>
                    </div>
                  </div>

                  <div class="recOptions">${optionsHtml}</div>

                  <div class="rec-popup-footer">
                    <div class="rec-popup-qty">
                      <button type="button" class="recQtyMinus">&minus;</button>
                      <span class="recQtyVal" data-qty="1">1</span>
                      <button type="button" class="recQtyPlus">+</button>
                    </div>
                    <button type="button" class="rec-popup-atc">Add To Cart</button>
                  </div>
                </div>

              `
              : `
                <product-form class="product-form">

                  <div
                    class="product-form__error-message-wrapper"
                    role="alert"
                    hidden
                  >
                    <span class="product-form__error-message"></span>
                  </div>

                  <form
                    method="post"
                    action="${window.Shopify.routes.root}cart/add"
                    accept-charset="UTF-8"
                    class="form"
                    data-type="add-to-cart-form"
                  >

                    <input
                      type="hidden"
                      name="id"
                      value="${variant.id}"
                    >

                    <div class="product-form__buttons">

                      <button
                        type="submit"
                        name="add"
                        class="product-form__submit button button--full-width cart-drawer-product-atc"
                        ${
                          variant.available
                            ? ""
                            : "disabled"
                        }
                      >

                        <span>
                          ${
                            variant.available
                              ? "Add to cart"
                              : "Sold out"
                          }
                        </span>

                      </button>

                    </div>

                  </form>

                </product-form>
              `
          }

        </div>
      `;

      recommendationsWrap.insertAdjacentHTML(
        "beforeend",
        productHtml
      );
    });
  }


  function escapeHtml(value) {
    const div = document.createElement("div");
    div.textContent = value || "";
    return div.innerHTML;
  }

  async function fetchCartRecommendations() {
    try {
      const cartResponse = await fetch(
        `${window.Shopify.routes.root}cart.js`
      );

      const cart = await cartResponse.json();

      await loadRecommendations(cart);

    } catch (error) {
      console.error(
        "Failed to fetch cart recommendations:",
        error
      );
    }
  }

  document.addEventListener('click', function (event) {
    const plusButton = event.target.closest('.recQtyPlus');
    const minusButton = event.target.closest('.recQtyMinus');

    if (!plusButton && !minusButton) return;

    const button = plusButton || minusButton;
    const qtyContainer = button.closest('.rec-popup-qty');

    if (!qtyContainer) return;

    const qtyVal = qtyContainer.querySelector('.recQtyVal');

    if (!qtyVal) return;

    let currentQty = parseInt(qtyVal.dataset.qty, 10) || 1;

    if (plusButton) {
      currentQty++;
    } else {
      currentQty = Math.max(1, currentQty - 1);
    }

    qtyVal.dataset.qty = currentQty;
    qtyVal.textContent = currentQty;
  });


  document.addEventListener('change', function (event) {
    if (!event.target.matches('#recPopupOverlay .recOptions select')) {
      return;
    }

    const select = event.target;
    const popup = select.closest('#recPopupOverlay');
    const optionsContainer = select.closest('.recOptions');

    if (!popup || !optionsContainer) return;

    const productId = popup.dataset.pid;

    const optionGroups = optionsContainer.querySelectorAll('.rec-popup-group');

    const selectedOption = Array.from(optionGroups)
      .map(group => group.querySelector('select')?.value || '')
      .join(' / ');

    const productElement = document.querySelector(
      `.recommendatiations-hidden-wrapper .recommendations-hidden-container[data-pid="${productId}"]`
    );

    if (!productElement) {
      console.error('Product data not found:', productId);
      return;
    }

    const variantElement = Array.from(
      productElement.querySelectorAll('.recommendations-hidden-item')
    ).find(variant => variant.dataset.title === selectedOption);

    if (!variantElement) {
      console.error('Variant not found:', selectedOption);
      return;
    }

    const variantId = variantElement.dataset.vid;
    const sellingPrice = Number(variantElement.dataset.price);
    const compareAtPriceValue = Number(variantElement.dataset.compPrice);

    if (!variantId || !Number.isFinite(sellingPrice)) {
      console.error('Invalid variant or selling price:', selectedOption);
      return;
    }

    function formatPrice(priceInCents) {
      return `${currency1}${(priceInCents / 100).toLocaleString(
        document.documentElement.lang || 'en-GB',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      )}`;
    }

    const priceElement = popup.querySelector(
      '.rec-popup-price .recPopupPrice'
    );

    const compareElement = popup.querySelector(
      '.rec-popup-price .rec-popup-compare'
    );

    if (priceElement) {
      priceElement.textContent = formatPrice(sellingPrice);
    }

    if (compareElement) {
      compareElement.textContent =
        Number.isFinite(compareAtPriceValue) &&
        compareAtPriceValue > sellingPrice
          ? formatPrice(compareAtPriceValue)
          : '';
    }

    // Keep the selected variant ID available for the Add to Cart handler.
    popup.dataset.variantId = variantId;
  });

  
  document.addEventListener('click', async function (event) {
    const addToCartButton = event.target.closest(
      '#recPopupOverlay .rec-popup-atc'
    );

    if (!addToCartButton) return;

    event.preventDefault();

    const popupBody = addToCartButton.closest('.rec-atc-popup-body');

    if (!popupBody) {
      console.error('Popup body not found');
      return;
    }

    // Get quantity from this product's popup
    const qtyElement = popupBody.querySelector('.recQtyVal');
    const qty = Math.max(1, parseInt(qtyElement?.dataset.qty, 10) || 1);

    // Get selected product options
    const optionGroups = popupBody.querySelectorAll('.rec-popup-group select');
    const selectedOptions = Array.from(optionGroups).map(
      select => select.value
    );

    const selectedVariant = selectedOptions.join(' / ');

    // Get product ID from the popup overlay
    const overlay = addToCartButton.closest('#recPopupOverlay');
    const productId = overlay?.getAttribute('data-pid');

    if (!productId) {
      console.error('Product ID not found on popup overlay');
      return;
    }

    // Find the matching hidden product container
      const productElement = document.querySelector(
      `.recommendatiations-hidden-wrapper .recommendations-hidden-container[data-pid="${productId}"]`
    );

    if (!productElement) {
      console.error('Product data not found:', productId);
      return;
    }

    // Match the selected options to a variant
    const variantElement = Array.from(
      productElement?.querySelectorAll('.recommendations-hidden-item') || []
    ).find(variant => variant.dataset.title === selectedVariant);

    const variantId = variantElement?.dataset.vid;
    const price = Number(variantElement?.dataset.price);
    const compareAtPrice = Number(variantElement?.dataset.compPrice);
    const sku = variantElement?.dataset.sku;
    const discount = Number(variantElement?.dataset.discount);
    const saleTitle = variantElement?.dataset.saleTitle;
    const saleEnabled = variantElement?.dataset.saleEnable === 'true';
    const sellingPolicy = variantElement?.dataset.sellingPolicy;

    if (!variantId) {
      alert('Please select a valid product option.');
      console.error('Variant not found:', selectedVariant);
      return;
    }

    // Prevent duplicate clicks while adding to cart
    if (addToCartButton.disabled) return;

    addToCartButton.disabled = true;

    const originalText = addToCartButton.textContent;
    addToCartButton.textContent = 'Adding...';

    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: qty
              }
            ]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add product to cart.'
        );
      }

      console.log('Product added to cart:', result);

      addToCartButton.textContent = 'Added!';

      await updateCart();

    } catch (error) {
      console.error('Add to cart error:', error);
      alert(error.message || 'Unable to add product to cart.');
      addToCartButton.textContent = originalText;

    } finally {
      addToCartButton.disabled = false;

      if (addToCartButton.textContent === 'Adding...') {
        addToCartButton.textContent = originalText;
      }
    }
  });


  document.addEventListener('click', async function (event) {
    const addToCartButton = event.target.closest(
      '.cart-drawer-recommendations button.product-form__submit.cart-drawer-product-atc'
    );

    if (!addToCartButton) return;

    event.preventDefault();

    // Prevent duplicate clicks
    if (addToCartButton.disabled) return;

    const productForm = addToCartButton.closest('.product-form');
    const variantId = productForm?.querySelector('input[name="id"]')?.value;
    const qty = 1;

    if (!variantId) {
      alert('Product is unavailable');
      return;
    }

    addToCartButton.disabled = true;
    const originalText = addToCartButton.textContent.trim();
    addToCartButton.textContent = 'Adding...';

    try {
      const response = await fetch(
        `${window.Shopify?.routes?.root || '/'}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: qty
              }
            ]
          })
        }
      );

      const result = await response.json();

      if (!response.ok) {
        throw new Error(
          result.description ||
          result.message ||
          'Unable to add product to cart.'
        );
      }

      console.log('Product added to cart:', result);

      addToCartButton.textContent = 'Added!';

      if (typeof updateCart === 'function') {
        await updateCart();
      }

    } catch (error) {
      console.error('Add to cart error:', error);

      alert(error.message || 'Unable to add product to cart.');
      addToCartButton.textContent = originalText;

    } finally {
      addToCartButton.disabled = false;

      if (addToCartButton.textContent === 'Adding...') {
        addToCartButton.textContent = originalText;
      }
    }
  });

  /********** End Cart Recommendations ************/


  // ---- Review / cart carousels ----
  function initSwiperCarousel(selector, nextEl, prevEl, extraOptions) {
    return new Swiper(
      selector,
      Object.assign(
        {
          slidesPerView: 1,
          spaceBetween: 10,
          grabCursor: true,
          navigation: { nextEl: nextEl, prevEl: prevEl }
        },
        extraOptions || {}
      )
    );
  }

  function initialize_slider() {
    initSwiperCarousel('.cart_review_slider', '.cart-review-btn-next', '.cart-review-btn-prev', { spaceBetween: 40 });
  }

  function initialize_prd_reviews() {
    initSwiperCarousel('.block_reviews', '.review-cart-prd-next', '.review-cart-prd-prev');
  }

  initialize_slider();
  initialize_prd_reviews();

  $(document).on('click', '.you_may_prd_btn', async function (e) {
    e.preventDefault();
    var variant_id = $(this).attr('prd-variant-id');

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: [{ id: variant_id, quantity: 1 }] },
      dataType: 'json',
      success: async function () {
        await updateCart();
        initialize_prd_reviews();
      }
    });
  });


  $(document).on('click', '.remove-button-2', async function () {
    var selected_variant_id = $(this).parents('.cart_qty_remove_btn').find('.cart_quantity .quantity').attr('name');

    const cart_inf = await fetch('/cart.js');
    await cart_inf.json();

    var updates_id = { updates: { [selected_variant_id]: 0 } };

    $.ajax({
      url: '/cart/update.js',
      data: updates_id,
      dataType: 'json',
      type: 'POST',
      success: async function (data) {
        if (data.items.length == 0) {
          try {
            const removeDiscountResponse = await fetch('/discount/CLEAR', {
              method: 'GET',
              headers: { 'Content-Type': 'application/json' }
            });

            if (!removeDiscountResponse.ok) {
              throw new Error('Failed to remove discount');
            }
          } catch (error) {
            console.error('Error removing discount:', error);
          }
        }

        await updateCart();
        initialize_slider();
      }
    });
  });

  // ---- Cart drawer open/close + delete/quantity rebinding ----

  function setUpButtons() {
    const cartOpenLink = document.querySelector('.w-commerce-commercecartopenlink');
    const closeButton = document.querySelector('.close-button');
    const cartOverlay = document.querySelector('.left_cart_drawer_side');

    if (cartOpenLink) {
      cartOpenLink.addEventListener('click', (e) => {
        e.preventDefault();
        openCart();
      });
    }

    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        closeCart();
      });
    }

    if (cartOverlay) {
      cartOverlay.addEventListener('click', (e) => {
        e.preventDefault();
        closeCart();
      });
    }
  }

  function closeCart() {
    const cartDrawer = document.querySelector('.cart-wrapper');
    if (cartDrawer) {
      cartDrawer.classList.remove('active_cart_drawer');
      cartDrawer.removeAttribute('data-cart-open');
    }
  }
  $('.left_cart_drawer_side').click(function () {
    closeCart();
  });

  function openCart() {
    const cartDrawer = document.querySelector('.cart-wrapper');
    if (cartDrawer) {
      cartDrawer.classList.add('active_cart_drawer');
    }

    fetchCartRecommendations();
  }

  async function updateCart() {
    const wrapper = $('.w-commerce-commercecartformwrapper.cart_drawer_items_wrapper');
    const loader = wrapper.find('.cart-total-loader');
    const cartWrapper = document.querySelector('.cart-wrapper');

    wrapper.addClass('show-loader');
    loader.removeClass('hide');

    try {
      const [sectionRes, cartRes] = await Promise.all([fetch('/?section_id=cart-drawer-pdp'), fetch('/cart.js')]);
      const [text, cart] = await Promise.all([sectionRes.text(), cartRes.json()]);

      const html = document.createElement('div');
      html.innerHTML = text;

      const newContent = html.querySelector('.cart-wrapper');
      if (newContent && cartWrapper) {
        cartWrapper.innerHTML = newContent.innerHTML;
      }

      setUpButtons();
      updateCounter(cart.item_count);
    } catch (error) {
      console.error('Cart update failed:', error);
    } finally {
      wrapper.removeClass('show-loader');
      loader.addClass('hide');
      $('.cart_quantity').removeClass('load_cart');
      $('#cart-checkout-button').removeClass('disabled-checkout');
    }

    fetchCartRecommendations();
  }

  function updateCounter(item_count) {
    const tmp = document.querySelector('.cart-quantity');
    tmp.textContent = item_count;
    if(item_count > 0){
      $('#mini-cart-items-all').css('visibility', 'visible');
    }else{
      $('#mini-cart-items-all').css('visibility', 'hidden');
    }
  }
  setUpButtons();

  // caesarCushiePersistHomepageVariantCartAttributes() twice in a row.
  async function submitAddToCart(formData, options) {
    options = options || {};

    const response = await fetch('/cart/add.js', { method: 'POST', body: formData });
    const data = await response.json();

    if (response.ok) {
      if (options.persistHomepageVariant) {
        await caesarCushiePersistHomepageVariantCartAttributes();
      }

      sendPostHogAddToCartSuccess({
        variant_id: data.variant_id || data.id,
        product_id: data.product_id,
        sku: data.sku,
        quantity: data.quantity
      });
    }

    openCart();
    await updateCart();

    return data;
  }

  // Shared cart drawer refresh for add-to-cart buttons in other scripts
  // (Complete the set in individual-product.js): same drawer update,
  // drawer buttons and "We Think You'll Love" list as the main Add To Cart.
  window.cushieRefreshCartDrawer = async function () {
    openCart();
    await updateCart();
  };

  const addToCartForms = document.querySelectorAll('form[action="/cart/add"]');

  if (addToCartForms.length > 0) {
    addToCartForms.forEach((form) => {
      let isRunning = false;
      const submitButton = form.querySelector('input[type="submit"]');

      if (!submitButton) return;

      submitButton.addEventListener('click', async (e) => {
        e.preventDefault();

        if (isRunning) return;
        isRunning = true;

        let but2 = document.getElementById('primar-button');
        let old_text2 = but2?.getAttribute('data-value') || 'Adding...';
        if (but2) {
          but2.value = 'Adding...';
        }

        try {
          const formData = new FormData(form);
          const button = e.currentTarget;

          if ($(button).attr('data-value') === 'Pre-Order') {
            const eta_preorder = $('input[name="eta_preorder"]').val();
            const start_date_hidden = $('input[name="pre_order_start_date"]').val();
            const end_date_hidden = $('input[name="pre_order_end_date"]').val();

            formData.append('properties[Pre Order - ETA]', eta_preorder);
            formData.append('properties[_pre_order_eta_start_date]', start_date_hidden);
            formData.append('properties[_pre_order_eta_end_date]', end_date_hidden);
          }

          await submitAddToCart(formData, { persistHomepageVariant: true });
        } catch (error) {
          console.error('Add to cart error:', error);
        } finally {
          if (but2) but2.value = old_text2;
          isRunning = false;
        }
      });
    });
  }

  const stickyAtcButton = document.querySelector('.sticky-atc-wrapper .sticky-atc-container .atcBtn button#sticky-atc-btn');

  if (stickyAtcButton) {
    let isRunning = false;

    stickyAtcButton.addEventListener('click', async function (e) {
      e.preventDefault();

      if (isRunning) return;

      const buttonEl = this;
      const buttonValue = buttonEl.getAttribute('data-value') || '';

      if (buttonValue.toLowerCase() === 'out of stock') {
        return;
      }

      /* const variantIdInput = document.querySelector('.speical-holder .add-to-cart-container .w-commerce-commerceaddtocartform input[name="id"]');

      const variantId = variantIdInput?.value; */

      const variantIdInput = document.querySelector('.sticky-variant-id');

      const variantId = variantIdInput?.value;

      if (!variantId || variantId === 'undefined') {
        console.log('Please select a valid variant before adding to cart.');
        return;
      }

      isRunning = true;

      const loadingText =
        buttonEl.getAttribute('data-loading-text') || 'Adding...';

      const originalText = buttonEl.innerHTML;

      buttonEl.disabled = true;

      buttonEl.innerHTML = `
        ${loadingText}
        <span class="sticky-atc-icon">
          <img
            src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/shopping-cart-white.svg?v=1756128418"
            alt="icon"
          >
        </span>
      `;

      try {
        const formData = new FormData();

        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (buttonValue === 'Pre-Order') {
          const etaPreorder =
            document.querySelector('input[name="eta_preorder"]')?.value || '';

          const startDate =
            document.querySelector('input[name="pre_order_start_date"]')?.value || '';

          const endDate =
            document.querySelector('input[name="pre_order_end_date"]')?.value || '';

          formData.append(
            'properties[Pre Order - ETA]',
            etaPreorder
          );

          formData.append(
            'properties[_pre_order_eta_start_date]',
            startDate
          );

          formData.append(
            'properties[_pre_order_eta_end_date]',
            endDate
          );
        }

        await submitAddToCart(formData);
        const stickyAtc = document.querySelector('.sticky-atc-wrapper');
        const topStickyAtc = document.querySelector('.top-sticky-atc-wrapper');

        if (stickyAtc) {
          stickyAtc.classList.add('zIndex');
        }

        if (topStickyAtc) {
          topStickyAtc.classList.add('zIndex');
        }

      } catch (error) {
        console.error('Add to cart error:', error);

      } finally {
        buttonEl.innerHTML = originalText;
        buttonEl.disabled = false;
        isRunning = false;
      }
    });
  }


  const topstickyAtcButton = document.querySelector('.top-sticky-atc-wrapper .top-sticky-atc-container .atcBtn button#top-sticky-atc-btn');

  if (topstickyAtcButton) {
    let isRunning = false;

    topstickyAtcButton.addEventListener('click', async function (e) {
      e.preventDefault();

      if (isRunning) return;

      const buttonEl = this;
      const buttonValue = buttonEl.getAttribute('data-value') || '';

      if (buttonValue.toLowerCase() === 'out of stock') {
        return;
      }

      const variantIdInput = document.querySelector('.speical-holder .add-to-cart-container .w-commerce-commerceaddtocartform input[name="id"]');

      const variantId = variantIdInput?.value;

      if (!variantId || variantId === 'undefined') {
        console.log('Please select a valid variant before adding to cart.');
        return;
      }

      isRunning = true;

      const loadingText = buttonEl.getAttribute('data-loading-text') || 'Adding...';

      const originalText = buttonEl.innerHTML;

      buttonEl.disabled = true;

      buttonEl.innerHTML = `${loadingText}`;

      try {
        const formData = new FormData();

        formData.append('id', variantId);
        formData.append('quantity', '1');

        if (buttonValue === 'Pre-Order') {
          const etaPreorder =
            document.querySelector('input[name="eta_preorder"]')?.value || '';

          const startDate =
            document.querySelector('input[name="pre_order_start_date"]')?.value || '';

          const endDate =
            document.querySelector('input[name="pre_order_end_date"]')?.value || '';

          formData.append(
            'properties[Pre Order - ETA]',
            etaPreorder
          );

          formData.append(
            'properties[_pre_order_eta_start_date]',
            startDate
          );

          formData.append(
            'properties[_pre_order_eta_end_date]',
            endDate
          );
        }

        await submitAddToCart(formData);
        const stickyAtc = document.querySelector('.sticky-atc-wrapper');
        const topStickyAtc = document.querySelector('.top-sticky-atc-wrapper');

        if (stickyAtc) {
          stickyAtc.classList.add('zIndex');
        }

        if (topStickyAtc) {
          topStickyAtc.classList.add('zIndex');
        }

      } catch (error) {
        console.error('Add to cart error:', error);

      } finally {
        buttonEl.innerHTML = originalText;
        buttonEl.disabled = false;
        isRunning = false;
      }
    });
  }

  var $updateButton = document.getElementById('updateButton');

  $(document).on('click', '.old-plus', function () {
    var $input = $(this).closest('.quantity-block').find('.quantity');
    var val = parseInt($input.val(), 10);
    $input.val(val + 1);
    $input[0].dispatchEvent(new Event('change'));
    $updateButton.click();
  });

  $(document).on('click', '.old-minus', function () {
    var $input = $(this).closest('.quantity-block').find('.quantity');
    var val = parseInt($input.val(), 10);
    $input.val(Math.max(val - 1, 1));
    $input[0].dispatchEvent(new Event('change'));
    $updateButton.click();
  });

  $('select[data-node-type="add-to-cart-option-select"]').change(function () {
    setTimeout(function () {
      location.reload();
    }, 1000);
  });

 
  let cartUpdateTimerPlus;
  let plusInitialQty = 0;

  $(document).on('pointerdown', '.plus', function () {
    if ($(this).hasClass('cart-qty-btn')) return;

    const $input = $(this).closest('.quantity-block').find('.quantity');
    const currentQty = parseInt($input.val());

    if (plusInitialQty === 0) {
      plusInitialQty = currentQty;
    }

    const maxQty = plusInitialQty + 15;

    if (currentQty >= maxQty) return;

    $input[0].stepUp();
    $input.trigger('input');

    clearTimeout(cartUpdateTimerPlus);

    cartUpdateTimerPlus = setTimeout(async function () {
      const key = $input.attr('name');
      const qty = $input.val();

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [key]: qty } })
        });

        await updateCart();
      } catch (error) {
        console.error('Error updating cart:', error);
      }

      plusInitialQty = 0;
    }, 500);
  });

  let cartUpdateTimerMinus;
  let initialQtyMapMinus = new Map();

  $(document).on('pointerdown', '.minus', function () {
    if ($(this).hasClass('cart-qty-btn')) return;

    const $input = $(this).closest('.quantity-block').find('.quantity');
    const key = $input.attr('name');
    const currentQty = parseInt($input.val(), 10);

    if (!initialQtyMapMinus.has($input[0])) {
      initialQtyMapMinus.set($input[0], currentQty);
    }

    const initialQty = initialQtyMapMinus.get($input[0]);
    const newQty = currentQty - 1;

    if (newQty < 1) return;
    if (initialQty - newQty > 15) return;

    $input[0].stepDown();
    $input.trigger('input');

    clearTimeout(cartUpdateTimerMinus);

    cartUpdateTimerMinus = setTimeout(async function () {
      const finalQty = parseInt($input.val(), 10);

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [key]: finalQty } })
        });

        await updateCart();
        initialQtyMapMinus.delete($input[0]);
      } catch (error) {
        console.error('Error updating cart:', error);
      }
    }, 500);
  });

  // ---- Size guide, dimensions thumbnails, reviews ----

  $('.size_guide').click(function () {
    $('.product_size_guide_container').addClass('active_size');
  });
  $('.close_size').click(function () {
    $('.product_size_guide_container').removeClass('active_size');
  });

  $('.dimensions_image_thumb img').click(function () {
    $('.dimensions_thumb_imgs').removeClass('active_thumb');
    var select_mode = $(this).attr('image-name');
    $(this).parents('.dimensions_thumb_imgs').addClass('active_thumb');
    $(this).parents('.dimensions_grid').find('.dimensions_images img').removeClass('active');
    $(this).parents('.dimensions_grid').find(`.dimensions_images img[name=${select_mode}]`).addClass('active');
  });

  $('.see_all_reviews').click(function () {
    const primarySection = $('#shopify-section-template--24566500294947__1746683689f837f62c');
    const fallbackSection = $('#shopify-section-template--24533156954403__174486990997d282ff');
    const targetSection = primarySection.length ? primarySection : fallbackSection;

    if (targetSection.length) {
      $('body, html').animate({ scrollTop: targetSection.offset().top - 20 }, 1000);
    }
  });


  if (window.innerWidth <= 1024) {
    var review_html = $('.review_layout_1').html();
    $('.mobile_review_layout_1').append(review_html);
  }

  $(document).on('click', '.mobile_review_layout_1 .review_all_btn', function () {
    $(this).closest('.swiper-slide').find('.review_content p').css('-webkit-line-clamp', 'inherit');
    $(this).hide();
  });

  $('.product_accordion_container .reviews_acordion_content .see_all_reviews').on('click', function (e) {
    e.preventDefault();
    if ($('.junip-product-review-rendered').length > 0) {
      $('html, body').animate({ scrollTop: $('.junip-product-review-rendered').offset().top }, 800);
    }
  });
});

// ----------------------------------------------------------------------------
// Variation swatch → monthly installment price + shipping properties
// ----------------------------------------------------------------------------

$(document).ready(function () {
  var divideValue = 12;

  setTimeout(function () {
    var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
    $('#properties').val(variation_date);
  }, 500);

  $('.variation-swatch').on('click', function () {
    var price = $(this).attr('data-variant-price');

    if (price) {
      var cleanPrice = parseFloat(price.replace(/[^0-9.]/g, ''));
      var monthly = (cleanPrice / divideValue).toFixed(2);
      var installmentText = currency1 + `${monthly}/Month `;

      /* $('.metafield-string').html(' '+installmentText); */
      
      $('.sale_cust_price_2 .original-price s').html(currency1 + `${price}`);
    }

    var variation_date = $('.variant_estimate_date:not(.hide)').data('ship-date');
    $('#properties').val(variation_date);
  });
});

$(document).ready(function() {
  // Set initial states
  $('.customsec_product .product_container img.hover_img').css('display', 'none');
  $('.customsec_product .product_container img.not_hover').css('display', 'block');

  // Hover in and out logic
  $('.customsec_product .product_container .add-to-cart-button').hover(
    function() { 
      // Mouse enter
      $('img.hover_img').css('display','block');
      $('img.not_hover').css('display','none');
    },
    function() {
      // Mouse leave
      $('img.hover_img').css('display','none');
      $('img.not_hover').css('display','block');
    }
  );
});

// ----------------------------------------------------------------------------
// Checkout button
// ----------------------------------------------------------------------------

function handleCheckoutClick(e) {
  const $btn = $(this);
  const $loadingText = $btn.attr('data-loading-text');

  if ($btn.hasClass('disabled-checkout')) return;

  e.preventDefault();

  if ($loadingText) {
    $btn.find('.checkBtnText').text($loadingText);
  }

  setTimeout(() => {
    $btn.find('.checkBtnText').text('Checkout');
  }, 1000);

  const url = $btn.attr('href');
  if (url) {
    window.location.href = url;
  }
}

// Event delegation on a stable parent means this only needs to be bound once,
// even across bfcache restores / cart drawer re-renders.
$(document).on('click', '#cart-checkout-button', handleCheckoutClick);

window.addEventListener('pageshow', function (event) {
  if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    console.log('Restored from bfcache – no need to rebind due to delegation');
  }
});